module.exports = __webpack_public_path__ + "static/headshot-mike-arpaia.ff4aac71.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/headshot-mike-arpaia.jpg
// module id = 128
// module chunks = 35783957827783 152909308826437